import axios from 'axios';

/**
 * Form yanıtları için API servisleri
 */
class AnswersService {
  constructor() {
    this.baseURL = 'https://app.hhoms.com/api/form';
    this.testURL = 'https://app.hhoms.com/test/form';
  }

  /**
   * Ortak headers oluştur
   */
  getHeaders(appToken, userId = null) {
    const headers = {
      'ApplicationToken': appToken,
      'Content-Type': 'application/json'
    };
    
    if (userId) {
      headers['User'] = userId;
    }
    
    return headers;
  }

  /**
   * Klasör bilgilerini çek
   */
  async loadFolders(appToken, userId) {
    try {
      console.log('Klasör bilgileri yükleniyor...');
      const response = await axios.get(`${this.baseURL}/Categories/list`, {
        headers: this.getHeaders(appToken, userId)
      });

      if (response.data && response.data.formCategories) {
        // Klasörleri ID'ye göre map'le
        const folderMap = {};
        const processFolders = (folderList) => {
          folderList.forEach(folder => {
            folderMap[folder.id] = folder.title;
            if (folder.detail && folder.detail.length > 0) {
              processFolders(folder.detail);
            }
          });
        };
        
        processFolders(response.data.formCategories);
        console.log('Yüklenen klasörler:', folderMap);
        console.log('Klasör sayısı:', Object.keys(folderMap).length);
        return folderMap;
      } else {
        console.warn('Klasör verisi bulunamadı');
        return {};
      }
    } catch (error) {
      console.error('Klasör bilgileri yüklenirken hata:', error);
      throw new Error('Klasör bilgileri yüklenirken bir hata oluştu.');
    }
  }

  /**
   * Form yanıtlarını çek
   */
  async loadResponses(appToken, userId) {
    try {
      const response = await axios.get(`${this.baseURL}/LibraryRecords/list/all/0`, {
        headers: this.getHeaders(appToken, userId)
      });

      if (response.data && Array.isArray(response.data.formLibraryRecords)) {
        const formattedResponses = response.data.formLibraryRecords.map(record => {
          // formContent ve formData'yı JSON.parse ile parse et
          let formContentObj;
          let formDataObj = {};
          
          try {
            formContentObj = typeof record.formContent === 'string' 
              ? JSON.parse(record.formContent)
              : record.formContent;
            
            formDataObj = typeof record.formData === 'string'
              ? JSON.parse(record.formData)
              : record.formData;
          } catch (error) {
            console.error('Veri parse edilirken hata:', error);
            formContentObj = {};
            formDataObj = {};
          }

          return {
            id: record.id,
            formId: record.formId,
            createDate: record.createDate,
            editDate: record.editDate,
            user: record.user,
            title: record.title,
            parentId: record.parentId,
            formContent: formContentObj,
            formData: formDataObj
          };
        });

        // Tarihe göre sırala
        return formattedResponses.sort((a, b) => 
          new Date(b.createDate) - new Date(a.createDate)
        );
      }
      
      return [];
    } catch (error) {
      console.error('Form yanıtları yüklenirken hata:', error);
      throw new Error('Form yanıtları yüklenirken bir hata oluştu.');
    }
  }

  /**
   * Form detaylarını çek
   */
  async getFormDetail(responseId, appToken, userId) {
    try {
      const response = await axios.get(`${this.baseURL}/LibraryRecords/${responseId}`, {
        headers: this.getHeaders(appToken, userId)
      });

      return response.data.formLibraryRecords[0];
    } catch (error) {
      console.error('Form detayları yüklenirken hata:', error);
      throw new Error('Form detayları yüklenirken bir hata oluştu.');
    }
  }

  /**
   * Form güncelle
   */
  async updateForm(formData, appToken) {
    try {
      const response = await axios.put(
        `${this.baseURL}/LibraryRecords`,
        formData,
        {
          headers: this.getHeaders(appToken)
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('Sunucu yanıtı başarısız');
      }
    } catch (error) {
      console.error('Form kaydedilirken hata:', error);
      throw new Error('Form kaydedilirken bir hata oluştu: ' + (error.response?.data?.message || error.message));
    }
  }

  /**
   * Form sil
   */
  async deleteForm(formId, description, appToken) {
    try {
      const response = await axios.delete(`${this.testURL}/LibraryRecords`, {
        headers: this.getHeaders(appToken),
        data: {
          id: formId,
          description: description.trim()
        }
      });
      
      return response.data;
    } catch (error) {
      console.error('Silme hatası:', error);
      throw new Error('Form silinirken bir hata oluştu: ' + (error.response?.data?.message || error.message));
    }
  }
}

// Singleton instance
const answersService = new AnswersService();
export default answersService;
